import React, { useEffect } from 'react';
import { isMobile, loadingStore, platformMessageStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { liveConnection } from '../../../../core';
import { gameService } from '../../../../services';
import { betStore } from '@pascal/pascal-core/shared/core/store';

const Game = observer(() => {
  const { isRepliedGame } = platformMessageStore;
  const { repliedBetData } = betStore;
  const { isPixiLoaded } = loadingStore;

  useEffect(() => {
    if (isRepliedGame && !isPixiLoaded) {
      liveConnection.executeThreeJsAnimation(true);
    }
  }, [isRepliedGame, isPixiLoaded]);

  useEffect(() => {
    if (repliedBetData && isPixiLoaded) {
      gameService.handleReplay(repliedBetData);
    }
  }, [repliedBetData, isPixiLoaded]);

  return <canvas id={'roulette-canvas'} width={isMobile() ? 640 : 1920} height={isMobile() ? 360 : 1080}></canvas>;
});

export default Game;
